import { combineReducers } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import { authSlice } from "./auth/auth.slice";
import { userSlice } from "./user/user.slice";
import { subscriptionSlice } from "./subscription/subscription.slice";
import storage from "redux-persist/lib/storage";

const getConfig = (key, whitelist) => {
  const persistConfig = {
    key: key,
    storage,
    whitelist,
  };
  return persistConfig;
};

export default combineReducers({
  auth: persistReducer(getConfig("auth", ["accessToken"]), authSlice.reducer),
  user: persistReducer(getConfig("user", ["fullName"]), userSlice.reducer),
  subscription: persistReducer(
    getConfig("subscription", ["statusText", "subStatus"]),
    subscriptionSlice.reducer
  ),
});
